// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"232":"3ae7ee45","648":"3bfe64a1"}[chunkId] + ".css";
};